import { render, staticRenderFns } from "./MakeOrderCard.vue?vue&type=template&id=2417bae2&scoped=true"
import script from "./MakeOrderCard.vue?vue&type=script&lang=js"
export * from "./MakeOrderCard.vue?vue&type=script&lang=js"
import style0 from "./MakeOrderCard.vue?vue&type=style&index=0&id=2417bae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417bae2",
  null
  
)

export default component.exports